<template>
  <div class="content">
    <p class="title" :class="{'has-text-white': white}">{{user.trackers.length}} Linked {{(user.trackers.length === 1) ? 'tracker' : 'trackers'}}</p>
    <p v-if="error" class="subtitle is-danger">{{error}}</p>
    <ul>
      <li
        v-for="id in user.trackers"
        :class="{'has-text-white': white}"
        :key="id">
          {{id}}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data: () => {
    return {
      error: null
    }
  },
  props: {
    white: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  async created () {
    if (!await this.$store.dispatch('checkAuthToken')) return this.$router.push('/login')
    this.error = await this.$store.dispatch('getUser')
  }
}
</script>
